import { Dialog } from '@headlessui/react';
import React from 'react';
import { priceFormater } from '@/settings';
import { ReplacedProduct } from '@/lib/collections/catalogue/helpers';
import { ShippingData } from './NewProductPage/types';
import PurchaseLinks, {
  ProductDetails,
} from '@/components/products/PurchaseLinks';
import { priceFormatSuperscript } from '@/lib/price';
import PriceInformation from '@/components/products/PriceInformation';
import { ProductSource } from '@/lib/analytics/types';
import { ParseMarkdown } from '@/components/markdown';

export default function ProductInfoPanel(props: {
  show: boolean;
  onClose: () => void;
  offer?: ReplacedProduct;
  vendor: string;
  category: string;
  warranty: number | null;
  price?: number;
  shippingData: ShippingData;
  deliverBy?: { min: string; max: string };
  subsidyTag?: string;
  productId: number;
  variantId: number;
  upgradation?: string;
  comparePrice?: number;
  isOutOfStock?: boolean;
  productDetails?: ProductDetails;
  categoryPk: string;
  categorySummary?: string;
}) {
  const { comparePrice, price, categorySummary } = props;

  return (
    <Dialog
      as="div"
      className="fixed inset-0 z-[50]"
      onClose={props.onClose}
      open={props.show}
    >
      <div className="min-h-screen px-4">
        <Dialog.Overlay className="fixed inset-0 overflow-y-scroll bg-gray-700/[.3]" />
        <div className="absolute right-0 inline-block h-full w-full overflow-auto bg-white text-left align-middle shadow-xl transition-all xl:w-10/12 2xl:w-1/3">
          <div className="sticky top-0 justify-between bg-white px-4 py-2 shadow">
            <Dialog.Title
              as="h3"
              className=" mr-6 block justify-start py-3 pr-2 text-[18px] font-bold leading-6 text-gray-700"
            >
              Certified Quality & Packaging
            </Dialog.Title>
            <button
              onClick={props.onClose}
              type="button"
              className="btn-close absolute right-6 top-[50%] -translate-y-1/2 justify-end opacity-100 md:h-3 md:w-3"
              aria-label="Close"
            ></button>
          </div>
          <div className="flex flex-col bg-white p-4 pb-[5rem] pt-4 text-[14px]">
            {categorySummary && (
              <ParseMarkdown
                markdown={categorySummary}
                variables={{}}
                size="base"
              />
            )}
          </div>
        </div>
      </div>
      <div
        className="fixed bottom-0 z-50 mt-4 flex w-full items-center gap-3 border-t border-gray-500 bg-white px-5 pb-4 pt-2.5 shadow-[0_-4px_9px_rgba(0,0,0,0.05)] sm:right-0 xl:w-10/12 2xl:w-1/3"
        id="purchaseCont"
      >
        <div className="flex w-1/2 flex-col items-start">
          {comparePrice ? (
            <PriceInformation
              actualPrice={price}
              comparePrice={comparePrice}
              view={'mobileBottom'}
            />
          ) : (
            <div className="flex flex-col items-start justify-end gap-x-2 xxs:flex-row xxs:items-center">
              <p className="block font-bold text-gray-700 xs:text-xl">
                {priceFormatSuperscript(priceFormater.long(price || 0))}
              </p>
            </div>
          )}
        </div>
        <div className="w-1/2">
          <PurchaseLinks
            offer={props.offer}
            vendor={props.vendor}
            category={props.category}
            warranty={props.warranty}
            shippingData={props.shippingData}
            deliverBy={props.deliverBy}
            subsidyTag={props.subsidyTag}
            productId={props.productId}
            variantId={props.variantId}
            cartButtonVariant="dark"
            upgradation={props.upgradation}
            productDetails={props.productDetails}
            isOutOfStock={props.isOutOfStock}
            comparePrice={comparePrice}
            className="grid w-full grid-cols-1 gap-1.5 py-0.5"
            productSource={ProductSource.WARRANTY}
            categoryPk={props.categoryPk}
          />
        </div>
      </div>
    </Dialog>
  );
}
